// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qj-8";
export var editMode = "_qj-3";
export var headerRow = "_qj-a";
export var headerTitle = "_qj-b";
export var product = "_qj-1";
export var productDetails = "_qj-5";
export var productDivider = "_qj-7";
export var productImage = "_qj-2";
export var productInfo = "_qj-4";
export var productTitle = "_qj-6";
export var strikethrough = "_qj-9";
export var upsellProductsCard = "_qj-0";